import pt from '../locales/pt';

/** @typedef {'essential' | 'lifestyle' | 'personal_investment'} QuickAllocation */

export const QUICK_ALLOCATION_OPTIONS = [
  {
    value: 'essential',
    label: pt.quickCreate.allocation.essential,
    dotClass: 'bg-group-needs',
  },
  {
    value: 'lifestyle',
    label: pt.quickCreate.allocation.lifestyle,
    dotClass: 'bg-group-wants',
  },
  {
    value: 'personal_investment',
    label: pt.quickCreate.allocation.savings,
    dotClass: 'bg-group-savings',
  },
];

export function allocationDotClass(value) {
  return (
    QUICK_ALLOCATION_OPTIONS.find((option) => option.value === value)?.dotClass ||
    'bg-group-needs'
  );
}
